import Route from 'mewe/routes/route';
import { inject as service } from '@ember/service';

export default Route.extend({
  publicId: false,
  router: service(),

  model(params) {
    this.publicId = params.group_public_id;

    return {
      groupPublicId: this.publicId,
    };
  },

  redirect() {
    this.router.replaceWith('/join/' + this.publicId + location.search);
  },
});
